package org.example.project.screens_sys

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.enginekalender.searchServiceKalenderBookings
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import org.example.project.service.GlobalManager
import org.example.project.enginekalender.parseHourMinute
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.ZustandManager
import org.example.project.utils.All

@Composable
fun SysTerminauskunft() {
    val kalenderLiveVersion = GlobalManager.jsonDomainVersion("kalender")
    var termine by remember { mutableStateOf<List<All>>(emptyList()) }
    var letzteFilter by remember { mutableStateOf<Map<String, String>?>(null) }
    val scope = rememberCoroutineScope()

    fun stundenAnzahl(termin: All): String {
        val start = parseHourMinute(termin.uhrzeitVon) ?: return ""
        val ende = parseHourMinute(termin.uhrzeitBis) ?: return ""
        val minuten = ende - start
        if (minuten <= 0) return ""
        val stunden = minuten / 60.0
        val whole = stunden.toInt().toDouble() == stunden
        return if (whole) stunden.toInt().toString() else stunden.toString().replace(".", ",")
    }

    fun kundenId(termin: All): String =
        termin.kundeFirmenId

    fun mapRow(termin: All): List<String> {
        val kid = kundenId(termin)
        return listOf(
            termin.id,
            kid,
            termin.kundeFirma,
            termin.terminArt.ifBlank { "Meeting" },
            termin.ort,
            ZustandManager.Termin.textFor(termin.zustand),
            termin.datum,
            termin.uhrzeitVon,
            termin.uhrzeitBis,
            stundenAnzahl(termin)
        )
    }

    LaunchedEffect(kalenderLiveVersion) {
        val filters = letzteFilter
        termine = if (filters == null) {
            emptyList()
        } else {
            runCatching { searchServiceKalenderBookings(filters) }.getOrDefault(emptyList())
                .filter { kundenId(it).isNotBlank() }
        }
    }

    TabularScreen(
        screenKey = "Terminauskunft",
        rollenKey = "Terminauskunft",
        title = "Terminauskunft",
        headers = listOf(
            "ID",
            "Kunden-ID",
            "Firma",
            "Terminart",
            "Termin Ort",
            "Zustand",
            "Termindatum",
            "Start",
            "Ende",
            "Stundenanzahl"
        ),
        models = termine,
        data = termine.map { termin -> termin.id to mapRow(termin) },
        editable = false,
        includeMetadata = true,
        allowCreate = false,
        allowDelete = false,
        onSearchWithFilters = { filters ->
            scope.launch {
                letzteFilter = filters
                termine = runCatching { searchServiceKalenderBookings(filters) }.getOrDefault(emptyList())
                    .filter { kundenId(it).isNotBlank() }
            }
        },
        onCommit = {}
    )
}
